import { Box, Link, Typography } from "@mui/material";
import { useExplorer } from "../../hooks/useExplorer";
import { explorerUrl } from "../../utils/explorer";

const TxSnackbarMessage = ({ message, txId }) => {
  // the transaction opens in the explorer chosen in the settings
  const explorer = useExplorer();
  return (
    <Box>
      <Typography component="div">{message}</Typography>
      {txId ? (
        <Link
          color="inherit"
          underline="always"
          target="_blank"
          rel="noopener noreferrer"
          href={explorerUrl(explorer, "tx", txId)}
          sx={{ fontSize: "0.85rem" }}
        >
          {`View on ${explorer.name}`}
        </Link>
      ) : null}
    </Box>
  );
};

export default TxSnackbarMessage;
